"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var white = '#ffffff';
var bsBorderBlue = '#80bdff';
var bsBorderGrey = '#ced4da';
var bsBoxShadowBlue = '0 0 0 0.2rem rgba(0, 123, 255, 0.25);';
var bsBackgroundOption = '#f8f9fa';
var bsBackgroundOptionSelected = '#eeeeee';
var bsControlTextColor = '#555555';
var bsControlPlaceholderColor = '#999999';
var styles = exports.styles = {
  control: function control(base, state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      height: 'calc(2.25rem + 4px)',
      minHeight: 34,
      backgroundColor: state.selectProps.isDisabled ? '#e9ecef' : white,
      borderWidth: 1,
      borderStyle: 'solid',
      boxShadow: state.selectProps.menuIsOpen ? bsBoxShadowBlue : null,
      color: bsControlTextColor,
      borderColor: state.selectProps.menuIsOpen ? bsBorderBlue : bsBorderGrey,
      ':hover': {
        borderColor: state.selectProps.menuIsOpen ? bsBorderBlue : bsBorderGrey
      }
    });
  },
  valueContainer: function valueContainer(base, state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      paddingLeft: 10
    });
  },
  input: function input(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: bsControlTextColor
    });
  },
  singleValue: function singleValue(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: bsControlTextColor
    });
  },
  placeholder: function placeholder(base, state) {
    return {
      display: state.selectProps.menuIsOpen ? 'none' : 'inline',
      color: bsControlPlaceholderColor,
      paddingLeft: 3
    };
  },
  // indicatorSeparator: base => ({
  //     display: 'none',
  // }),
  // clearIndicator: base => ({
  //     ...base,
  //     borderWidth: 0,
  //     borderLeftWidth: 1,
  //     borderStyle: 'solid',
  //     borderColor: bsBorderGrey,
  //     backgroundColor: bsBackgroundGrey,
  //     height: '100%',
  //     width: 39,
  //     color: bsControlTextColor,
  //     ':hover': {
  //         color: bsControlTextColor,
  //     },
  // }),
  // dropdownIndicator: base => ({
  //     ...base,
  //     borderWidth: 0,
  //     borderLeftWidth: 1,
  //     borderStyle: 'solid',
  //     borderColor: bsBorderGrey,
  //     borderTopRightRadius: 4,
  //     borderBottomRightRadius: 4,
  //     backgroundColor: bsBackgroundGrey,
  //     height: '100%',
  //     width: 39,
  //     color: bsControlTextColor,
  //     ':hover': {
  //         color: bsControlTextColor,
  //     },
  // }),
  option: function option(base, state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: bsControlTextColor,
      backgroundColor: state.isSelected ? bsBackgroundOptionSelected : state.isFocused ? bsBackgroundOption : white
    });
  }
};